import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Building2, GraduationCap, Clock } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import { analyticsService } from '@meiuca/analytics'
import { H2, Body } from '@meiuca/ui-components'
import { MarketplaceHeader } from '@/components/MarketplaceHeader'
import { MarketplaceFooter } from '@/components/MarketplaceFooter'
import { ExploreCategoryCard } from '@/components/explore/ExploreCategoryCard'
import { ANALYTICS_EVENTS, SCREEN_NAMES } from '@/constants/analyticsEvents'

interface ExploreCategory {
  id: 'arenas' | 'professores' | 'rotativos'
  title: string
  description: string
  icon: LucideIcon
  path: string
}

const CATEGORIES: ExploreCategory[] = [
  {
    id: 'arenas',
    title: 'Arenas',
    description: 'Quadras e espaços para jogar',
    icon: Building2,
    path: '/arenas/search'
  },
  {
    id: 'professores',
    title: 'Professores',
    description: 'Centros de treinamento para evoluir seu jogo',
    icon: GraduationCap,
    path: '/cts/search'
  },
  {
    id: 'rotativos',
    title: 'Rotativos',
    description: 'Entre em jogos abertos perto de você',
    icon: Clock,
    path: '/rotativos/search'
  }
]

export function ExplorePage() {
  const navigate = useNavigate()

  useEffect(() => {
    analyticsService.trackScreenView(SCREEN_NAMES.EXPLORE)
  }, [])

  const handleCategoryClick = (category: ExploreCategory) => {
    analyticsService.track(ANALYTICS_EVENTS.EXPLORE_CATEGORY_CARD_CLICKED, {
      category: category.id
    })
    navigate(category.path)
  }

  return (
    <div className="min-h-screen bg-background-secondary flex flex-col">
      <MarketplaceHeader />

      <main className="flex-1 max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="text-center mb-8">
          <H2 className="text-text-primary">O que você procura?</H2>
          <Body className="text-text-secondary mt-2">Escolha uma opção para começar</Body>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 max-w-4xl mx-auto">
          {CATEGORIES.map((category) => (
            <ExploreCategoryCard
              key={category.id}
              icon={category.icon}
              title={category.title}
              description={category.description}
              onClick={() => handleCategoryClick(category)}
            />
          ))}
        </div>
      </main>

      <MarketplaceFooter />
    </div>
  )
}
